// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	SetToSalePriceButton: 'set-to-sale-price-button',
	SetToCalculatedValueButton: 'set-to-calculated-value-button',
	SourceOfPropertyValueDropdown: 'source-of-property-value-dropdown',
	PropertyValue: 'property-value',
	CustomSourceOfPropertyValue: 'custom-source-of-property-value',
	TotalOutstandingMortgageAmount: 'total-outstanding-mortgage-amount',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
